export const unescapeSingleDoubleQuotesAndBackslash = (
  input: string,
): string => {
  // Replace escaped single quote, double quote, and backslash with their unescaped versions
  const unescapedString = input
    .replace(/\\'/g, '0x27;')
    .replace(/\\"/g, '0x22;')
    .replace(/\\\\/g, '0x5c;');

  return `${unescapedString}`;
};

//TODO: remove this when parser changes lands
export const revertSpecialCharacters = (input: string): string => {
  // Replace unescaped single quote, double quote, and backslash with their escaped versions
  const escapedString = input
    .replace(/0x27;/g, "'")
    .replace(/0x22;/g, '"')
    .replace(/0x5c;/g, '\\');

  return `${escapedString}`;
};

export const revertContainsOperatorWildcardCharacters = (
  input: string,
): string => {
  return input.replace(/^%|%$/g, ''); // Remove % from the start & end
};
